import React from 'react'
import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonListHeader,
  IonLabel,
  IonList,
  IonItem,
  IonFooter,
  IonButtons,
  IonButton,
  IonIcon,
} from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { chevronForward } from 'ionicons/icons'
import { preventPageScroll } from '../../../utilities/preventPageScroll.util'
import { setPdfId, setShowModal, setPdfName } from '../store/fillablePDFs.actions'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { getFillablePDFOptionsSelector } from '../../options/selectors'

interface IFillablePDFModalProps {
  showModal: boolean
}

const FillablePDFsModal: React.FC<IFillablePDFModalProps> = (props: IFillablePDFModalProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { showModal } = props
  const fillablePDFsOptionsState = useSelector(getFillablePDFOptionsSelector)
  const { metadata } = fillablePDFsOptionsState

  const cancel = () => {
    dismiss()
  }

  const dismiss = () => {
    dispatch(setShowModal(false))
    preventPageScroll(false)
  }

  const handlePDFOnClick = (id: any, name: string) => {
    dispatch(setPdfId(id))
    dispatch(setPdfName(name))
    history.push(AppRouterConstants.FILLABLE_PDFS_ROUTE)
    dismiss()
  }

  return (
    <IonModal
      data-testid='FillablePDFModal'
      showBackdrop={showModal}
      isOpen={showModal}
      onDidDismiss={dismiss}
      className='multi-select-modal'>
      <IonHeader className='ion-no-border'>
        <IonToolbar color='light'>
          <IonListHeader color='light'>
            <IonLabel>{t('fillablePDFs.selectAPdfType')}</IonLabel>
          </IonListHeader>
        </IonToolbar>
      </IonHeader>
      <IonList>
        {metadata &&
          Array.isArray(metadata) &&
          metadata.map((pdf: any) => (
            <IonItem
              key={`PDF_${pdf.FormNameWithId}`}
              data-skip-auto-enhance
              onClick={() => handlePDFOnClick(pdf.FormNameWithId, pdf.FormName)}>
              <IonLabel>{pdf.FormName}</IonLabel>
              <IonIcon size='small' icon={chevronForward} />
            </IonItem>
          ))}
      </IonList>
      <IonFooter className='ion-no-border'>
        <IonToolbar color='light' className='p-10'>
          <IonButtons>
            <IonButton
              data-testid='MultiSelectCancel'
              className='btn btn-secondary mr-8'
              expand='block'
              id='multiselect-modal-cancel-button'
              onClick={() => cancel()}>
              {t('common.buttons.Cancel')}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonModal>
  )
}

export default FillablePDFsModal
